export type BadgeRank = 1 | 2 | 3

export const RANK_LABELS: Record<BadgeRank, string> = {
  1: "Rank I",
  2: "Rank II",
  3: "Rank III",
}

// Subtle per-rank glow behind the real badge artwork — silver/gold/purple,
// matching the material progression described in the badge design docs.
export const RANK_GLOW: Record<BadgeRank, string> = {
  1: "rgba(148, 163, 184, 0.35)",
  2: "rgba(245, 158, 11, 0.45)",
  3: "rgba(168, 85, 247, 0.55)",
}

export interface EarnedBadge {
  slug: string
  name: string
  description: string
  rank: BadgeRank
  value: number
}
